import { Checkbox, TableCell, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateBusinessPackageAction } from "redux/reducers/packagesReducer";
import { AppColors } from "resources/AppColors";

export function PackageTableRows({ intervention }) {
  const [status, setStatus] = useState(
    intervention.status === "ACTIVE" ? true : false
  );

  const dispatch = useDispatch();

  const handleStatus = (event) => {
    const updatedStatus = event.target.checked ? "ACTIVE" : "INACTIVE";
    const packageObject = {
      id: intervention.id,
      status: updatedStatus,
    };
    dispatch(updateBusinessPackageAction(intervention.id, packageObject));
    setStatus(event.target.checked);
  };

  const wizardTitle = intervention.wizards
    .map((wizard) => wizard.title)
    .join(", ");

  return (
    <>
      <TableCell align='left'>
        <Typography variant='body_semi_bold'>{intervention.name}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Checkbox
          checked={status}
          onChange={handleStatus}
          style={{ color: AppColors.PRIMARY }}
          inputProps={{ "aria-label": "controlled" }}
        />
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>
          {wizardTitle ? wizardTitle : "-"}
        </Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body_semi_bold'>{intervention.physicalActivityType || "-"}</Typography>
      </TableCell>
    </>
  );
}
